import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'

import { createServicesStyle } from '../../../resources/styles/CreateServiceStyles'
import TextBox from '../../common/TextBox'
import ButtonSaved from '../../common/Buttons/ButtonSaved'
import { Grid } from '@material-ui/core'

const PricelessComponent = (props) => {
    const { emails, canEditEmails, isSaving, isModeCreate, onSaveEmails, showNoPricePanel} = props
    const [pricelessForm, setPricelessForm] = useState({ EmailsContact: emails || '' })
    const classes = createServicesStyle()

    useEffect(() => {
        setPricelessForm({ EmailsContact: emails || '' })
    }, [emails])

    if (!showNoPricePanel) return null;

    const onPropertyChange = event => {
        let { name, value } = event.target
        setPricelessForm({
            ...pricelessForm,
            [name]: value
        })
    }

    const onUpdateData = () => {
        console.log('onUpdateData called', pricelessForm.EmailsContact)
        if (onSaveEmails) {
            onSaveEmails(pricelessForm.EmailsContact)
        }
    }

    const canBeSaved = () => {
        return !!pricelessForm.EmailsContact
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextBox
                    key="EmailsContact"
                    active={true}
                    disabled={!canEditEmails || !isModeCreate}
                    fullWidth
                    multiline={true}
                    name="EmailsContact"
                    rows={1}
                    variant="outlined"
                    margin="dense"
                    label="EMAILS TO SEND NOTIFICATIONS e.g. (correo@correo.com,)"
                    onChange={onPropertyChange}
                    value={pricelessForm.EmailsContact}
                    inputProps={{
                        style: { fontSize: 12 }
                    }}
                />
            </Grid>
            {canEditEmails && isModeCreate && (
                <Grid item xs={12} className={classes.updateButton}>
                    <ButtonSaved
                        onSavedClick={onUpdateData}
                        title="Save"
                        isSaving={isSaving || !canBeSaved()}
                    />
                </Grid>
            )}
        </Grid>
    )
}

PricelessComponent.propTypes = {
    emails: propTypes.string,
    canEditEmails: propTypes.bool,
    isSaving: propTypes.bool,
    isModeCreate: propTypes.bool,
    onSaveEmails: propTypes.func,
    showNoPricePanel: propTypes.bool
}

PricelessComponent.defaultProps = {
    emails: '',
    canEditEmails: false,
    isSaving: false,
    isModeCreate: true,
    onSaveEmails: () => console.warn('Callback [onSaveEmails] not defined'),
    showNoPricePanel: false
}

export default PricelessComponent